if (!customElements.get('back-in-stock')) {
  customElements.define(
    'back-in-stock',
    class BackInStock extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          formPostedSuccess: 'form-posted--success',
          formPostedError: 'form-posted--error'
        }

        this.bisModal = this.closest('modal-dialog');
        this.form = this.querySelector('form');
        this.formSubmit = this.form.querySelector('[type="submit"]');
        this.inputEmail = this.form.querySelector('input[name="email"]');
        this.selectVariant = this.form.querySelector('select[name="variant"]');

        this.initEvents();
        
      }

      variantChangeUnsubscriber = undefined;
      
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variantId = event.data.variant.id.toString();
          if (this.selectVariant.querySelector(`option[value="${variantId}"]`)) {
            this.selectVariant.value = variantId;
          }
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        
      }

      initEvents() {
        this.bisModal.addEventListener('hide', this.resetForm.bind(this));
        this.form.addEventListener('submit', this.onFormSubmit.bind(this));       
      }

      onFormSubmit(e) {
        e.preventDefault(); 
        this.resetForm(); 
        this.formSubmit.disabled = true;

        const klaviyoPublicApiKey = typeof klaviyoModulesObject !== 'undefined' && klaviyoModulesObject.hasOwnProperty('companyId') ? klaviyoModulesObject.companyId : window.klaviyoPublicApiKey;

        const data = {
          email: this.inputEmail.value,
          variant: this.selectVariant.value
        }

        const payload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                    "type": "profile",
                    "attributes": {
                      "email": data.email
                    }
                }
              },
              "channels": ["EMAIL"],
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": "$shopify:::$default:::" + data.variant
                }
              }
            }
          }
        }
        
        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoPublicApiKey}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision":"2024-06-15"
          },
          body: JSON.stringify(payload)
        })
        .then(response => {
          this.form.classList.add(this.classes.formPostedSuccess);
          console.log('Successful subscription to variant: ' + data.variant);
          console.log(response);
        })
        .catch(error => {
          this.form.classList.add(this.classes.formPostedError);
          console.error('Couldn\'t subscribe to back in stock');
          console.error('Error:', error);
        })
        .finally(() => {
          this.formSubmit.disabled = false;
        });
          
      }

      resetForm() {
        this.form.classList.remove(this.classes.formPostedError, this.classes.formPostedSuccess);
      }
      
    }
  )
}